import { IUserModel, userInitialState } from './user.model'
import { ICourseModel } from './course.model'
import { ISynchronousCourseEnrol } from './synchronousCourseEnrol.model'
import { EnrolState } from 'enum'

export interface SynchronousCourseProperties {
  minimumGrade?: number
  maximumGrade?: number
}

export interface IEnrolModel {
  id?: number
  state: EnrolState
  stateAdmin: EnrolState
  note: string
  userId: number
  courseId: number
  user: IUserModel
  course: ICourseModel
  createdAt?: string
  answer?: string
  answerAdmin?: string
  finishDate?: string
  supervisorApproved?: IUserModel
  adminApproved?: IUserModel
  data?: any
  area?: any
  synchronousCourseEnrol?: ISynchronousCourseEnrol
  manuallyAssigned?: boolean
  imported?: boolean
}

export const enrolInitialState: IEnrolModel = {
  state: 0,
  stateAdmin: 0,
  note: '',
  userId: 0,
  courseId: 0,
  user: <IUserModel>userInitialState,
  course: <ICourseModel>{},
}
